import queryString from 'query-string';
import { api, type IFetchApiProps } from './api';
import type { TListResponse } from '~/types';

export const QK_FETCH_NOTIFICATIONS = 'qk_fetch_notifications';

export interface IGetNotiResponse {
  id: string;
  url: string;
  type: string;
  title: string;
  read: boolean;
  message: string;
  createdAt: string;
  recipientId: string;
}

export interface IGetNotificatiosRequest extends IFetchApiProps {
  page?: number;
}

function getNotifications({
  page,
  signal,
}: IGetNotificatiosRequest): Promise<TListResponse<IGetNotiResponse>> {
  return api.get(
    queryString.stringifyUrl(
      {
        url: '/notifications',
        query: {
          'page[number]': page,
        },
      },
      {
        arrayFormat: 'bracket',
      },
    ),
    {
      signal,
    },
  );
}

export interface IMarkAsReadRequest {
  id: string;
}

function markAsRead({ id }: IMarkAsReadRequest) {
  return api.post(`/notifications/${id}/mark_as_read`);
}

function markAllAsRead() {
  return api.post('/notifications/mark_all_as_read');
}

export interface IRegisterDeviceRequest {
  token: string;
}

function registerDevice({ token }: IRegisterDeviceRequest) {
  return api.post('/notifications/devices', {
    device: { token },
  });
}

export const notiApi = {
  markAsRead,
  markAllAsRead,
  registerDevice,
  getNotifications,
} as const;
